import {
  SET_ALL_INDI_PROGRAMS,
  SET_INDI_PROGRAMS,
} from './types';
import { SetRegValueHelper, SpreadOps } from '../helper';

const initialState = {
  list: [],
  count: 0,
  all: {
    list: [],
    count: 0,
  }
};

var temp = "";
initialState.values = SpreadOps({ ...initialState.default });

export default function (state = initialState, action) {
  switch (action.type) {

    case SET_INDI_PROGRAMS:
      return {
        ...state,
        list: action.data.list,
        count: action.data.count,
      }

    case SET_ALL_INDI_PROGRAMS:
      return {
        ...state,
        all: {
          list: action.data.list,
          count: action.data.count,
        }
      }


    default:
      return state

  }
}
